module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page-w720.173b83ee.webp";